import {
  BankingCardLimitPeriodEnum,
  BankingValueObjectsCardTypeEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const cardTypeMap: Record<BankingValueObjectsCardTypeEnum, () => string> = {
  physical: () => i18n.t('expenses_v2.cards.type.physical'),
  virtual: () => i18n.t('expenses_v2.cards.type.virtual'),
  single_use: () => i18n.t('expenses_v2.cards.type.single_use'),
}

export const translateCardType = (cardType: BankingValueObjectsCardTypeEnum) =>
  cardTypeMap[cardType]()

const periodMap: Record<BankingCardLimitPeriodEnum, () => string> = {
  daily: () => i18n.t('banking.cards.card_controls.periods.daily'),
  weekly: () => i18n.t('banking.cards.card_controls.periods.weekly'),
  monthly: () => i18n.t('banking.cards.card_controls.periods.monthly'),
  yearly: () => i18n.t('banking.cards.card_controls.periods.yearly'),
}

export const translatePeriod = (period: BankingCardLimitPeriodEnum) => periodMap[period]()
